import { ActionCreator } from 'redux';

import {
    DialogState,
    DisableDialogAction,
    HideDialogAction,
    ShowDialogAction,
    ShowDialogParams,
    UpdateDialogAction,
    isIdBasedDialog,
} from './types';
import { ApplicationState } from '..';

const assignExplicitDialogParams = (params: ShowDialogParams) => {
    if (isIdBasedDialog(params)) {
        return {
            id: params.id,
        };
    }

    return {
        title: params.title,
        body: params.body,
        onClickCancel: params.onClickCancel,
        onClickConfirm: params.onClickConfirm,
        onClickDelete: params.onClickDelete,
        cancelLabel: params.cancelLabel,
        confirmLabel: params.confirmLabel,
        deleteLabel: params.deleteLabel,
        fullScreen: params.fullScreen,
        isDisabled: params.isDisabled,
        width: params.width,
        height: params.height,
        id: params.id,
        onClickDestructive: params.onClickDestructive,
        destructiveLabel: params.destructiveLabel,
        customButtons: params.customButtons,
        disableHeader: params.disableHeader,
        disableFooter: params.disableFooter,
        isHiddenManually: params.isHiddenManually,
        disabledContentPadding: params.disabledContentPadding,
        header: params.header,
        isLoading: params.isLoading,
        onClose: params.onClose,
    };
};

export const ShowDialog = (params: ShowDialogParams): ShowDialogAction => ({
    type: '@@dialog/SHOW',
    payload: {
        isOpened: true,
        ...assignExplicitDialogParams(params),
    },
});

export const UpdateDialog: ActionCreator<UpdateDialogAction> = (params: ShowDialogParams): UpdateDialogAction => ({
    type: '@@dialog/UPDATE',
    payload: {
        isOpened: true,
        ...assignExplicitDialogParams(params),
    },
});

export const HideDialog: ActionCreator<HideDialogAction> = (): HideDialogAction => ({
    type: '@@dialog/HIDE',
    payload: {
        isOpened: false,
    },
});

export const DisableDialog = (disabled: boolean): DisableDialogAction => ({
    type: '@@dialog/DISABLE',
    payload: {
        isDisabled: disabled,
    },
});

export const getDialogStore = (state: ApplicationState): DialogState => state.dialog;
